// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import CompanyAbout from "../CompanySections/CompanyAbout";
import CompanyOwnership from "../CompanySections/CompanyOwnership";
import CompanyProducts from "../CompanySections/CompanyProducts";
import CompanyShipments from "../CompanySections/CompanyShipments";
import {Tabs, Tab} from "react-bootstrap";
// import Translate from "react-translate-component";
import company from "../../imgs/company.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleRight,
  faAngleDoubleLeft,
} from "@fortawesome/free-solid-svg-icons";
import "./CompanyProfile.css";
class CompanyProfile extends Component {
  handleNextDetails = () => {
    let navTabs = document.querySelector(".nav-tabs");
    // 190 is the width of each tab name
    navTabs.scrollLeft += 190;
  };
  handlePrevDetails = () => {
    let navTabs = document.querySelector(".nav-tabs");
    navTabs.scrollLeft -= 190;
  };
  render() {
    return (
      <div className="container">
        <div className="company-container pt-5">
          <div className="company__title">
            <h3>Company Name:</h3>
            <h2>Al-Marai</h2>
          </div>
          <div className="company__logo__container">
            <div className="company__logo">
              <img src={company} alt={company} />
            </div>
          </div>
          <div className="arrows">
            <FontAwesomeIcon
              icon={faAngleDoubleLeft}
              onClick={() => this.handlePrevDetails()}
            />
            <FontAwesomeIcon
              icon={faAngleDoubleRight}
              onClick={() => this.handleNextDetails()}
            />
          </div>
          <Tabs defaultActiveKey="about" id="noanim-tab-example">
            <Tab eventKey="about" title="ABOUT">
              <CompanyAbout />
            </Tab>
            <Tab eventKey="ownership" title="OWNERSHIP, BOD AND EM">
              <CompanyOwnership />
            </Tab>
            <Tab eventKey="details" title="PRODUCT DETAILS">
              <CompanyProducts />
            </Tab>
            <Tab eventKey="shipment" title="SHIPMENT RECORD">
              <CompanyShipments />
            </Tab>
            <Tab eventKey="contact" title="Extra 1">
              <h1>Extra 1</h1>
            </Tab>
            <Tab eventKey="contact2" title="Extra 2">
              <h1>Extra 2</h1>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default CompanyProfile;
